import intl from 'react-intl-universal';
import React, { useEffect, useState, useMemo } from 'react';
import { SidePanelFilter } from '@getsynapse/design-system';
import { RequestFilters } from 'utils/types/filters';
import { REQUEST_TABLE_FILTERS } from 'utils/constants';
import RequestsFiltersForm from './RequestsFiltersForm/RequestsFiltersForm';

const RequestsSidePanelFilters: React.FC<{
  open: boolean;
  onUpdateFilters: (filters: RequestFilters) => void;
  onClose: () => void;
  filters: RequestFilters;
}> = ({ onClose, open, filters, onUpdateFilters }) => {
  const [appliedFilters, setAppliedFilters] = useState<RequestFilters>({});
  const [canApplyFilters, setCanApplyFilters] = useState<boolean>(false);

  const appliedFiltersCount = useMemo(() => {
    const { openRequests, myRequests, ...standardFilters } = appliedFilters;
    return Object.keys(standardFilters).length;
  }, [appliedFilters]);

  useEffect(() => {
    if (filters) {
      setAppliedFilters(filters);
    }
  }, [filters]);

  const handleUpdateFilters = (updatedFilters: RequestFilters) => {
    setAppliedFilters(updatedFilters);
    setCanApplyFilters(true);
  };

  const handleApplyFilters = () => {
    onUpdateFilters(appliedFilters);
    setCanApplyFilters(false);
  };

  const handleClearStandardFilters = () => {
    if (appliedFiltersCount === 0) return;

    const { openRequests, myRequests, ...standardFilters } = filters;
    const filtersCount = Object.keys(standardFilters).length;

    if (filtersCount) {
      onUpdateFilters({
        [REQUEST_TABLE_FILTERS.MY_REQUESTS]:
          filters[REQUEST_TABLE_FILTERS.MY_REQUESTS],
        [REQUEST_TABLE_FILTERS.OPEN_REQUESTS]:
          filters[REQUEST_TABLE_FILTERS.OPEN_REQUESTS],
      });
    }
    setAppliedFilters({
      [REQUEST_TABLE_FILTERS.MY_REQUESTS]:
        filters[REQUEST_TABLE_FILTERS.MY_REQUESTS],
      [REQUEST_TABLE_FILTERS.OPEN_REQUESTS]:
        filters[REQUEST_TABLE_FILTERS.OPEN_REQUESTS],
    });
    setCanApplyFilters(false);
  };

  return (
    <SidePanelFilter
      open={open}
      onClose={onClose}
      appliedFiltersCount={appliedFiltersCount}
      canApplyFilters={canApplyFilters}
      onClearAllFilters={handleClearStandardFilters}
      onApplyFilters={handleApplyFilters}
      data-testid='activeRequests-filters-side-panel'
      applyButtonLabel={intl.get('FILTER_PANEL.APPLY')}
      clearAllButtonLabel={intl.get('FILTER_PANEL.CLEAR_ALL')}
    >
      <RequestsFiltersForm
        filters={appliedFilters}
        onUpdateFilters={handleUpdateFilters}
      />
    </SidePanelFilter>
  );
};

export default RequestsSidePanelFilters;
